import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { Button, Tabs, Typography } from "antd";
import { useHistory } from "react-router-dom";
import moment from "moment";


import AccountProfile from "@pages/AccountPage/components/AccountProfile";
import AccountSubscription from "@pages/AccountPage/components/AccountSubscription";
import AccountBidHistory from "@pages/AccountPage/components/AccountBidHistory";
// import AccountChangePassword from "@pages/AccountPage/components/AccountChangePassword";
import { getRemainTurnQuery, getUserQuery } from "@dataLayer/user";
import { DATE_TIME_FORMAT, PATHS } from "@config/constants";
import { PACKAGE_CYCLE } from "@pages/AccountPage/components/AccountSubscription";

import "./index.scss";
import AccountReferral from './components/AccountReferral';
import AccountGift from './components/AccountGift';
import { useLocation } from "react-router-dom";

const { TabPane } = Tabs;
const { Title, Text } = Typography;
const AccountPage = () => {
  // const {state} = useLocation();
  const location = useLocation();
  const DEFAULT_TAB = "tab_1";
  // const [currentTab, setCurrentTab] = useState(state?.isPagePack ? "tab_4" : DEFAULT_TAB);
  const history = useHistory();
  const { t } = useTranslation();
  const { data: pack } = useQuery(getRemainTurnQuery());
  const { data: user, isLoading } = useQuery(getUserQuery());
  const packagePack = pack?.filter((pack) => pack?.type === 1)?.[0];

  const params = new URLSearchParams(location.search);
  const tabFromUrl = params.get('tab');

  const [currentTab, setCurrentTab] = useState(tabFromUrl || DEFAULT_TAB);

  const callback = (key) => {
    setCurrentTab(key);
    // Cập nhật URL khi đổi tab
    history.replace(`${location.pathname}?tab=${key}`);
  };

  // Sync nếu URL thay đổi từ bên ngoài
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get('tab');
    if (tab) setCurrentTab(tab);
  }, [location.search]);
  console.log('tabFromUrl: ', tabFromUrl)

  // const callback = (key) => {
  //   setCurrentTab(key);
  // }

  const handleClickBuy = () => {
    setCurrentTab("tab_4");
  }

  useEffect(() => {
    document.title = t("title.account");
    if (!user && !isLoading) {
      history.push(PATHS.LOGIN_PAGE);
    }
  }, [user, isLoading, history, t]);

  const isExpired =
    packagePack?.pack_id &&
    moment(packagePack?.next_charge_time).isBefore(moment());
  return (
    <div className="account-page">
      <div className="account-page-wrapper">
        {/* {currentTab === DEFAULT_TAB && (
          <div className="account-page-item">
            <Title level={4} className="account-page-item-number">
              {packagePack?.pack_id
                ? t("remain_package_turn")
                    .replace("_TURN_", packagePack?.turn || 0)
                    .replace(
                      "_TYPE_",
                      `/ ${
                        PACKAGE_CYCLE[
                          packagePack?.pack_id?.split("_")[1].toLowerCase()
                        ]
                      }`
                    )
                    .replace(
                      "_BIDS_",
                      `${
                        packagePack?.turn === 1 || packagePack?.turn === 0
                          ? t("bid.bid")
                          : t("bid.bids")
                      }`
                    )
                : t("account.not_register")}
            </Title>
            {
              !!packagePack?.turn && (
                <Text className="account-page-item-date">
                  {t("account.expired_on").replace(
                    "_DATE_",
                    moment(packagePack?.next_charge_time).format(
                      DATE_TIME_FORMAT
                    ) || ""
                  )}
                </Text>
              )
              // :
              // <Button className="account-page-item-button" onClick={handleClickBuy}>{t("account.buy_more")}</Button>
            }
            <Text className="account-page-item-expired">
              {isExpired && t("account.expired")}
            </Text>
          </div>
        )} */}
        <Tabs
          activeKey={currentTab}
          className="account-page-tabs"
          onTabClick={callback}>
          <TabPane tab={t("account.profile")} key="tab_1">
            <AccountProfile />
          </TabPane>
          <TabPane tab={t("account.bid_history")} key="tab_2">
            <AccountBidHistory />
          </TabPane>
          {/* <TabPane tab={t("account.change_password")} key="tab_3">
            <AccountChangePassword />
          </TabPane> */}
          <TabPane tab={t("account.subscription")} key="tab_4">
            <AccountSubscription />
          </TabPane>
          <TabPane tab={t("account.Referral_code")} key="tab_5">
            <AccountReferral />
          </TabPane>
          <TabPane tab={t("account.Gift_code")} key="tab_6">
            <AccountGift />
          </TabPane>
        </Tabs>
      </div>
    </div>
  );
};

export default AccountPage;
